const Input = ({ label, error, hint, className = '', ...props }) => (
  <div className="mb-4">
    {label && (
      <label className="block text-sm font-medium text-slate-700 mb-1.5">{label}</label>
    )}
    <input
      className={`
        w-full px-3.5 py-2.5 rounded-xl border text-sm text-slate-900 bg-white
        placeholder:text-slate-400
        shadow-inner-sm
        focus:outline-none focus:ring-2 focus:ring-offset-0 transition-all duration-150
        ${error
          ? 'border-red-400 focus:border-red-400 focus:ring-red-500/20'
          : 'border-slate-200 hover:border-slate-300 focus:border-primary-400 focus:ring-primary-500/20'
        }
        disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    />
    {hint && !error && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    {error && (
      <p className="mt-1 text-xs text-red-600 flex items-center gap-1">
        <svg className="w-3.5 h-3.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        {error}
      </p>
    )}
  </div>
);

export default Input;
